/* eslint-disable multiline-ternary */

import React from 'react'
import { Button, Typography, Skeleton } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { categoryUrl } from '../../helpers/url'
import { Link } from 'react-router-dom'

export const useStyles = makeStyles(({ palette, typography, spacing }) => ({
  root: {},
  ghost: {
    marginRight: spacing(1),
    borderRadius: 6,
    height: '2.5em'
  },
  topic: {
    ...typography.body.s,
    background: palette.grey.shade[5],
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: palette.grey.shade[10],
    boxSizing: 'border-box',
    borderRadius: 6,
    marginRight: spacing(1),
    marginBottom: spacing(1),
    color: palette.grey.shade[80],
    fontWeight: typography.fontWeightRegular,
    '& b': {
      fontWeight: typography.fontWeightBold
    }
  },
  topicBranded: {
    ...typography.body.s,
    background: palette.primary.main,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: palette.primary.main,
    boxSizing: 'border-box',
    borderRadius: 6,
    marginRight: spacing(1),
    marginBottom: spacing(1),
    color: palette.common.white,
    fontWeight: typography.fontWeightRegular,
    '& b': {
      fontWeight: typography.fontWeightBold
    },
    '&:hover': {
      background: palette.primary.dark,
      borderColor: palette.primary.dark
    }
  },
  title: {
    textTransform: 'capitalize',
    marginBottom: spacing(2),
    fontWeight: typography.fontWeightBold
  },
  box: {
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
  }
}))

const Topics = ({ className = '', category, topics, onClick, path, loading, useBrandColors = false }) => {
  const classes = useStyles()

  const renderAll = tops =>
    tops.map((topic, i) => (
      <Button
        component={Link}
        key={topic.sk}
        to={categoryUrl(topic, path)}
        underline='none'
        onClick={() => onClick(topic)}
        className={useBrandColors ? classes.topicBranded : classes.topic}
        data-test={`topic-${i}`}
      >
        {topic.name}&nbsp;<b>({topic.itemsCount})</b>
      </Button>
    ))
  const renderGhosts = num =>
    [...Array(num)].map((x, i) => (
      <Skeleton key={i} className={classes.ghost}>
        <Button />
      </Skeleton>
    ))
  return (
    <div
      className={className}
      data-test='topics'
    >
      <Typography
        variant='h5'
        component='h2'
        className={classes.title}
        data-test='topics-title'
      >
        {category && !loading ? (
          <> Explore {category.name} topics </>
        ) : (
          <Skeleton width='40%' />
        )}
      </Typography>
      <div className={classes.box}>
        {topics ? renderAll(topics) : renderGhosts(5)}
      </div>
    </div>
  )
}

export default Topics
